"use client";

import * as prismic from "@prismicio/client";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicText } from "@prismicio/react";
import { Swiper, SwiperSlide } from "swiper/react";

import { sliderLayout3 } from "@/utils/swiperOptions";

function formatDate(date) {
  if (!date) return { day: "", month: "" };

  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "short" }).toUpperCase();

  return { day, month };
}

export function RelatedArticlesSlider({ articles = [] }) {
  if (!articles.length) return null;

  return (
    <Swiper {...sliderLayout3} className="swiper-container slider-layout-3">
      {articles.map((article) => {
        const date = prismic.asDate(
          article.data.publishDate || article.first_publication_date
        );
        const { day, month } = formatDate(date);
        const categoryName =
          article.data?.category_name?.data?.category_name || "Article";

        return (
          <SwiperSlide key={article.id}>
            <div className="article-blog-item hover-img">
              <div className="image-wrap">
                <PrismicNextLink document={article} className="block">
                  {prismic.isFilled.image(article.data.featuredImage) ? (
                    <PrismicNextImage
                      className="lazyload"
                      field={article.data.featuredImage}
                      alt={prismic.asText(article.data.title) || ""}
                    />
                  ) : (
                    <div className="aspect-[4/3] w-full bg-gray-100" />
                  )}
                </PrismicNextLink>
                {day && month && (
                  <div className="date-time">
                    <div className="content">
                      <p className="entry-day ">{day}</p>
                      <p className="entry-month fw-book">{month}</p>
                    </div>
                  </div>
                )}
              </div>
              <div className="content">
                <p className="sub">{categoryName}</p>
                <div className="title text-4xl font-medium tracking-wide  leading-relaxed">
                  <PrismicNextLink document={article}>
                    <PrismicText field={article.data.title} />
                  </PrismicNextLink>
                </div>
                {prismic.isFilled.richText(article.data.excerpt) ? (
                  <p>
                    <PrismicText field={article.data.excerpt} />
                  </p>
                ) : (
                  <p>{article.data.meta_description}</p>
                )}
              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
